/* eslint-disable react/prop-types */
// Moisture.jsx
import React from 'react'
import High from './High'
import Low from './Low'

const MoistureDefault = ({ high, low, style }) => <Moisture high={high} low={low} style={style} />

export default MoistureDefault

const Moisture = ({ style, low, high }) => {
  const svgStyle = {
    fill: '#284047',
    stroke: '#284047',
    strokeLinejoin: 'round',
    strokeMiterlimit: '10',
    strokeWidth: 3,
    ...style,
  }
  return (
    <svg

      viewBox='0 0 75 75'
    >
      <g
        style={{
          transform: 'translate(1px, 9px) scale(.5)',
        }}
      >
        <g style={svgStyle}>
          <path
            fill='none'
            d='M100.5,74.9 c0,15.7-12.8,28.5-28.5,28.5S43.5,90.6,43.5,74.9s0-15.7,28.5-63.1C100.5,59.1,100.5,59.1,100.5,74.9z'
          />
          <path fill='none' d='M48.7,51c16.7,0,33.5,13.8,50.2,13.8' />
          <polygon
            stroke='none'
            points='49.6,50.6 61.1,53.1 75.8,59 92.3,64.3 99.8,64.4 99.9,78.4 97.4,87.6 92.1,94.9 86.8,99.1
        77.4,102.8 68,103.1 58.4,100.3 52.3,94.9 46.4,86.9 43.9,78.3 43,68.6 45.5,57.4'
          />
        </g>
      </g>
      {!!high && (
        <g id='high' transform='translate(40,40) scale(.4)'>
          <High />
        </g>
      )}

      {!!low && (
        <g id='low' transform='translate(40,40) scale(.4)'>
          <Low />
        </g>
      )}
    </svg>
  )
}
